<template>
	<v-menu
		ref="menu"
		v-model="menuDatePicker"
		:close-on-content-click="false"
		:return-value.sync="costsPayment.pay_date"
		transition="scale-transition"
		offset-y
		min-width="auto"
		eager
	>
		<template v-slot:activator="{ on, attrs }">
			<div
				class="date-viewer"
				v-bind="attrs"
				v-on="on"
			>
				<div v-if="costsPayment.pay_date" class="text-center font-weight-bold body-2">
					{{costsPayment.pay_date | toDateFormat}}
				</div>
				<div v-else>
					<p class="text-center mb-0 caption">Seleccionar</p>
				</div>
			</div>
		</template>
		<v-date-picker
			v-model="costsPayment.pay_date"
			no-title
			scrollable
			:first-day-of-week="1"
			locale="es-cl"
			:events="holidays"
			:picker-date.sync="pickerDate"
			event-color="red lighten-1"
			@input="(date) => $refs.menu.save(date)"
			@change="updateDate"
			class="pb-4"
		/>
	</v-menu>
</template>

<script>
import moment from "moment"
import {getHolidays} from '@/helpers/api/schedule'

export default {
	name: 'DateSelector',
	computed: {
		holidays(){
			return this.currentYearHolidays || this.$store.state.general.holidayDays
		}
	},
	props: {
		costsPayment: {
			type: Object,
			required: true
		},
		onDateChange: {
			type: Function,
			default: null
		}
	},
	watch: {
		currentYear(newValue, oldValue){
			if(newValue != oldValue && this.menuDatePicker){
				this.updateHolidays()
			}
		},
		pickerDate(newValue){
			if(newValue){
				this.currentYear = moment(newValue).format('YYYY')
			}
		},
		menuDatePicker(newValue){
			if(newValue){
				this.updateHolidays()
			}
		},
	},
	data() {
		return{
			menuDatePicker: false,
			selectedDate: null,
			currentYear: 2024,
			pickerDate: null,
			currentYearHolidays: null,
		}
	},
	mounted(){
		this.selectedDate = this.documentDate
	},
	methods: {
		async updateHolidays(){
			const holidays = await getHolidays({year: this.currentYear})
			if(holidays.code == 200){
				this.currentYearHolidays = holidays.events
			}
		},
		updateDate(date){
			if(date){
				this.costsPayment.pay_date = moment(date).format('YYYY-MM-DD')
			}
			this.menuDatePicker = false
			if (typeof this.onDateChange === 'function') {
				this.onDateChange(moment(date).format('YYYY-MM-DD'), this.costsPayment)
			}
		}
	}
}
</script>